import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./ordens-servico.component.html')
})
export class OrdensServicoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordens-servico.component.ts
 **/